export const SET_DYNAMIC_BUNDLE_PRICE = 'SET_DYNAMIC_BUNDLE_PRICE';

export const SET_LIST_QUANTITY_BUNDLE = 'SET_LIST_QUANTITY_BUNDLE';

export const UPDATE_QUANTITY_BUNDLE = 'UPDATE_QUANTITY_BUNDLE';

export const INIT_DYNAMIC_BUNDLE = 'INIT_DYNAMIC_BUNDLE';

